import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SignInScreen from './SignInScreen'
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<SignInScreen/>, document.getElementById('root'));
registerServiceWorker();
